import { render, staticRenderFns } from "./OtherEmissions.vue?vue&type=template&id=196c37a2"
import script from "./OtherEmissions.vue?vue&type=script&lang=js"
export * from "./OtherEmissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports